import {makeReducer} from '~/shared/store/redux-toolbelt';

import {setIsAgeConfirmed} from './ageRestrictionActions';

export default makeReducer<boolean>(setIsAgeConfirmed, {
  defaultState: false,
});
